import React, { Component } from "react";

class CompassBackPage extends Component {
  render() {
    return (
      <div className="roi-backpage-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/CompassCustom-Back-Cover_NOV_101626.jpg"
          className="roi-backpage-container-img"
          alt="COMPASS seller Back Page November 2026"
        />
      </div>
    );
  }
}

export default CompassBackPage;
